import script from "./PacEstabelecimentoForm_16.vue?vue&type=script&setup=true&lang=js"
export * from "./PacEstabelecimentoForm_16.vue?vue&type=script&setup=true&lang=js"

import "./PacEstabelecimentoForm_16.vue?vue&type=style&index=0&id=000540ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000540ae"]])

export default __exports__